import { render, staticRenderFns } from "./PdfModalComponent.vue?vue&type=template&id=3649fcaf&scoped=true"
import script from "./PdfModalComponent.vue?vue&type=script&lang=js"
export * from "./PdfModalComponent.vue?vue&type=script&lang=js"
import style0 from "./PdfModalComponent.vue?vue&type=style&index=0&id=3649fcaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3649fcaf",
  null
  
)

export default component.exports